import React, { createContext, useContext, useEffect, useState, useRef } from "react";
import {
  returningChatStartingResponse,
  chatSartingQuestions,
} from "../utils/constants";
import { defaultPaywallModalMessage } from "../utils/constants";
import { chatStartingResponse } from "../utils/constants";
import { getUserSession } from "../api/user";

const AppContext = createContext(null);

const defaultState = {
  userData: {},
  currentMessages: [],
  messageThreads: [returningChatStartingResponse],
  hasShownHistory: false,
  requireSignIn: false,
};
const defaultResponseFlowState = {
  review: false,
  line: true,
  text: true,
  question1: [
    true,
    chatSartingQuestions[0].message,
    chatSartingQuestions[0].tickers,
    false,
    null,
  ],
  question2: [
    true,
    chatSartingQuestions[1].message,
    chatSartingQuestions[1].tickers,
    false,
    null,
  ], //not starting with advanced
  regen: true,
};

const freshResponseFlow = () => ({
  ...defaultResponseFlowState,
  question1: [...defaultResponseFlowState.question1],
  question2: [...defaultResponseFlowState.question2],
});

export const AppProvider = ({ children }) => {
  // from App.js

  const [userData, setUserData] = useState(defaultState.userData);
  const [currentMessages, setCurrentMessages] = useState(
    defaultState.currentMessages
  );
  const [inputPlaceholderText, setInputPlaceholderText] = useState(""); //startPlaceholderText)
  const [messageThreads, setMessageThreads] = useState(
    defaultState.messageThreads
  ); //.concat(chatSartingQuestions))
  const [termsOfUseOpen, setTermsOfUseOpen] = useState(false);
  const [privacyPolicyOpen, setPrivacyPolicyOpen] = useState(false);
  const [accountModalOpen, setAccountModalOpen] = useState(false);
  const [testVar, setTestVar] = useState(null);
  const [allowSetShit, setAllowSetShit] = useState(false);
  const [disclosureOpen, setDisclosureOpen] = useState(false);
  const [loadingUserData, setLoadingUserData] = useState(true);
  const [loadingUserMessages, setLoadingUserMessages] = useState(false);
  const [hasShownHistory, setHasShownHistory] = useState(
    defaultState.hasShownHistory
  );
  const [responseFlow, setResponseFlow] = useState(freshResponseFlow());
  const [responseFlowByThreadUuid, setResponseFlowByThreadUuid] = useState({});
  const [questionButton, setQuestionButton] = useState([]);
  const [registerNavMessage, setRegisterNavMessage] = useState(null);
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false);
  const [showChatShare, setShowChatShare] = useState(false);
  const [isNewUUID, setIsNewUUID] = useState(null);
  const [showSignUpModal, setShowSignUpModal] = useState(false);
  const [showPaywallModal, setShowPaywallModal] = useState(false);
  const [showPastDueModal, setShowPastDueModal] = useState(false);
  const [watchlistData, setWatchlistData] = useState({});
  const [lastRequestedUpdateWatchlist, setLastRequestedUpdateWatchlist] =
    useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [hasErroredWatchlist, setHasErroredWatchlist] = useState(false);
  const [paywallMessage, setPaywallMessage] = useState(
    defaultPaywallModalMessage
  );
  const [conversionGateContext, setConversionGateContext] = useState(null);
  const [showWatchlistBlueDot, setShowWatchlistBlueDot] = useState(false);
  const [showWatchlistFlicker, setShowWatchlistFlicker] = useState(false);
  const [showPaywallAfter, setShowPaywallAfter] = useState(false);
  const [panel, setPanel] = useState("chat");

  const [messagesByThreadUuid, setMessagesByThreadUuid] = useState({});

  const watchlistWebsocketConnected = useRef(false)
  const liveChartWebsocketConnected = useRef(false)

  const websocketSubscriptionRef = useRef(null); // this is the ref for websocket subscriptions

  let value = {
    // from App.js
    userData,
    setUserData,
    currentMessages,
    setCurrentMessages,
    inputPlaceholderText,
    setInputPlaceholderText,
    messageThreads,
    setMessageThreads,
    termsOfUseOpen,
    setTermsOfUseOpen,
    privacyPolicyOpen,
    setPrivacyPolicyOpen,
    accountModalOpen,
    setAccountModalOpen,
    testVar,
    setTestVar,
    allowSetShit,
    setAllowSetShit,
    disclosureOpen,
    setDisclosureOpen,
    loadingUserData,
    setLoadingUserData,
    loadingUserMessages,
    setLoadingUserMessages,
    hasShownHistory,
    setHasShownHistory,
    responseFlow,
    setResponseFlow,
    responseFlowByThreadUuid,
    setResponseFlowByThreadUuid,
    freshResponseFlow,
    questionButton,
    setQuestionButton,
    registerNavMessage,
    setRegisterNavMessage,
    hasAcceptedTerms,
    setHasAcceptedTerms,
    showChatShare,
    setShowChatShare,
    isNewUUID,
    setIsNewUUID,
    showSignUpModal,
    setShowSignUpModal,
    showPaywallModal,
    setShowPaywallModal,
    watchlistData,
    setWatchlistData,
    lastRequestedUpdateWatchlist,
    setLastRequestedUpdateWatchlist,
    isRefreshing,
    setIsRefreshing,
    hasErroredWatchlist,
    setHasErroredWatchlist,
    paywallMessage,
    setPaywallMessage,
    conversionGateContext,
    setConversionGateContext,
    showWatchlistBlueDot,
    setShowWatchlistBlueDot,
    showWatchlistFlicker,
    setShowWatchlistFlicker,
    showPaywallAfter,
    setShowPaywallAfter,
    messagesByThreadUuid, setMessagesByThreadUuid,
    showPastDueModal, setShowPastDueModal,
    watchlistWebsocketConnected,
    liveChartWebsocketConnected,
    websocketSubscriptionRef,
  };

  // I will eventually remove this, becuase we will access separately.
  const requestClearChatMessageHistory = async () => {
    clearStateData();
  };

  const clearStateData = () => {
    setUserData({ uuid: userData.uuid }); // set to just be uuid, set first!
    setCurrentMessages(defaultState.currentMessages);
    setConversionGateContext(null);
    // setMessageThreads(defaultState.messageThreads.concat(chatSartingQuestions))
    setMessageThreads([chatStartingResponse].concat(chatSartingQuestions));
    setResponseFlow((responseFlow) => ({
      ...responseFlow,
      question1: [true, chatSartingQuestions[0].message],
      question2: [true, chatSartingQuestions[1].message],
    }));
    setResponseFlowByThreadUuid({});
    setHasShownHistory(defaultState.hasShownHistory);
    setMessagesByThreadUuid({});
    getUserSession(userData.uuid, userData.current_session_id); // get sesion so that we have it
  };

  const appProps = {
    userData: userData, //object
    setUserData: setUserData, //function
    loadingUserData: loadingUserData,
    setLoadingUserData: setLoadingUserData,
    currentMessages: currentMessages, //object
    setCurrentMessages: setCurrentMessages, //function
    requestClearChatMessageHistory: requestClearChatMessageHistory, //function
    termsOfUseOpen: termsOfUseOpen,
    setTermsOfUseOpen: setTermsOfUseOpen,
    privacyPolicyOpen: privacyPolicyOpen,
    setPrivacyPolicyOpen: setPrivacyPolicyOpen,
    accountModalOpen: accountModalOpen,
    setAccountModalOpen: setAccountModalOpen,
    clearStateData: clearStateData,
    disclosureOpen: disclosureOpen,
    setDisclosureOpen: setDisclosureOpen,
    responseFlow: responseFlow,
    setResponseFlow: setResponseFlow,
    responseFlowByThreadUuid: responseFlowByThreadUuid,
    setResponseFlowByThreadUuid: setResponseFlowByThreadUuid,
    freshResponseFlow: freshResponseFlow,
    setMessageThreads,
    setMessageThreads,
    allowSetShit: allowSetShit, //rename or remove?
    setAllowSetShit: setAllowSetShit, //rename or remove?
    testVar: testVar, //rename or remove?
    setTestVar: setTestVar, //rename or remove?
    setQuestionButton: setQuestionButton,
    inputPlaceholderText: inputPlaceholderText,
    setInputPlaceholderText: setInputPlaceholderText,
    messageThreads: messageThreads,
    hasShownHistory: hasShownHistory,
    setHasShownHistory: setHasShownHistory,
    hasAcceptedTerms: hasAcceptedTerms,
    setHasAcceptedTerms: setHasAcceptedTerms,
    registerNavMessage: registerNavMessage,
    setRegisterNavMessage: setRegisterNavMessage,
    showChatShare: showChatShare,
    setShowChatShare: setShowChatShare,
    isNewUUID,
    showSignUpModal: showSignUpModal,
    setShowSignUpModal: setShowSignUpModal,
    showPaywallModal,
    setShowPaywallModal,
    loadingUserMessages: loadingUserMessages,
    setLoadingUserMessages: setLoadingUserMessages,
    watchlistData: watchlistData,
    setWatchlistData: setWatchlistData,
    lastRequestedUpdateWatchlist: lastRequestedUpdateWatchlist,
    setLastRequestedUpdateWatchlist: setLastRequestedUpdateWatchlist,
    isRefreshing: isRefreshing,
    setIsRefreshing: setIsRefreshing,
    hasErroredWatchlist: hasErroredWatchlist,
    setHasErroredWatchlist: setHasErroredWatchlist,
    paywallMessage: paywallMessage,
    setPaywallMessage: setPaywallMessage,
    conversionGateContext,
    setConversionGateContext,
    showWatchlistBlueDot: showWatchlistBlueDot,
    setShowWatchlistBlueDot: setShowWatchlistBlueDot,
    showWatchlistFlicker: showWatchlistFlicker,
    setShowWatchlistFlicker: setShowWatchlistFlicker,
    showPaywallAfter: showPaywallAfter,
    setShowPaywallAfter: setShowPaywallAfter,
    panel: panel,
    setPanel: setPanel,
  };

  value = {
    ...value,
    appProps,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useAppContext = () => useContext(AppContext);
